import { render, staticRenderFns } from "./EditBan.vue?vue&type=template&id=338f791a&"
import script from "./EditBan.vue?vue&type=script&lang=js&"
export * from "./EditBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports